'use es6';

export default class TreeNode {
  constructor(props) {
    if (!props.id) {
      throw new TypeError('Tree nodes require an id props');
    }
    this.id = props.id;
    this.children = props.children || [];
  }
}